import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';

@Component({
  standalone: false,
  selector: 'app-view-query',
  templateUrl: './view-query.component.html'
})
export class ViewQueryComponent implements OnInit {
  queryId: any;
  queryList: any;

  constructor(private service: MainService, private activatedRoute: ActivatedRoute) {
    this.activatedRoute.params.subscribe((res) => {
      this.queryId = res.id;
    })
  }

  ngOnInit(): void {
    this.getQueryList()

  }

  // get faq by id
  getQueryList() {
    this.service.showSpinner();
    this.service.getApi(ApiUrls.view_query + `?_id=${this.queryId}`, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.queryList = res.result;
        this.service.hideSpinner();
        // this.mainService.successToast(res.responseMessage);
      } else {
        this.service.hideSpinner();
        this.service.errorToast(res.responseMessage)
      }
    })
  }

}
